import {OnboardingVersionV3} from '@/dataSource/src/api/users/constants';
import {IDeviceEventSchema} from '@/services/segment/models/DeviceEventModel';
import {
  IEventBaseDataSchema,
  IEventDataSchema,
  TrackingEvent,
} from '@/services/segment/models/TrackingManagerEventModel';
import {
  IMoEngageUserEvent,
  IUserEventSchema,
} from '@/services/segment/models/UserEventModel';

import {getCoparentingSchema, getDeviceInfo} from './utils';
import {ErrorType, getErrorSchema} from './utils/getErrorSchema';
import {
  getUserSchema,
  transformUserToUserForMoEngageUser,
} from './utils/getUserSchema';

export const trackEventLogic = ({
  eventName,
  eventData,
  trackEventService,
  error,
  trackPii = false,
  showEmailAndPhone = false,
  familyId,
  extraData,
}: {
  eventName: TrackingEvent;
  eventData: IEventBaseDataSchema;
  trackEventService: (
    eventName: TrackingEvent,
    event: IEventDataSchema,
  ) => void;
  error?: ErrorType;
  trackPii?: boolean;
  showEmailAndPhone?: boolean;
  familyId?: string;
  extraData?: Object;
}) => {
  const deviceInfo: IDeviceEventSchema = getDeviceInfo();
  const user: IUserEventSchema = getUserSchema(eventData?.user);
  const {user_uuid, user_type}: IMoEngageUserEvent =
    transformUserToUserForMoEngageUser(user?.user);
  const errorSchema = getErrorSchema(error);
  const coparentingSchema = getCoparentingSchema();
  const event: IEventDataSchema = {
    ...(familyId && {organization_id: familyId}),
    ...deviceInfo,
    ...eventData,
    ...user,
    ...(extraData && {extraData}),
    Onboarding: {
      version: OnboardingVersionV3,
    },
    ...coparentingSchema,
    user_uuid,
    user_type,
    ...errorSchema,
  };

  if (!event.event || !event.event.action) {
    event.event = {
      action: eventName,
    };
  }

  if (!trackPii) {
    event.user.first_name = undefined;
    event.user.last_name = undefined;
    event.user.name = undefined;
    event.user.address = undefined;
  }

  if (!showEmailAndPhone) {
    event.user.email = undefined;
    event.user.phone = undefined;
  }

  trackEventService(eventName, event);
};
